import React, { Component } from "react";
import html2canvas from "html2canvas";
import PropTypes from "prop-types";
import {
  Modal,
  Container,
  Row,
  Col,
  FormGroup,
  FormLabel,
  FormControl,
  InputGroup,
  FormCheck,
  OverlayTrigger,
  Popover,
  Button,
} from "react-bootstrap";
import i18n from "i18next";
import RangeSlider from "./range_slider/RangeSlider";
import Select from "react-select";
import { WithContext as ReactTags } from "react-tag-input";
import {
  suggestions,
  statusOptions,
  contextOptions,
  languages,
  difLevels,
  rightsOptions,
} from "./global_options";
import { getContentLanguage, CONTENT_LANGUAGES } from "../../../../common/content_language";

import Alert from "./../../common/alert/Alert";
import ToggleSwitch from "@trendmicro/react-toggle-switch";
import { normalizeSceneMandatoryDefaults } from "../../../../common/sceneDefaults.es6";
import "@trendmicro/react-toggle-switch/dist/react-toggle-switch.css";
const img_place_holder =
  "data:image/png;base64,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";

// Styles
import "./_globalConfig.scss";
import "./_reactTags.scss";
import FileInput from "../../common/file-input/FileInput";
import RatioPicker from "./RatioPicker";
import SceneDefaultsSection from "./SceneDefaultsSection";
import CourseFontSection from "./CourseFontSection";
import { getValueFromPreset } from "../../../../core/editor/ratio_presets";
import { COURSE_MODES, getCourseMode } from "../../../../common/clm.es6";
import AppModal from "../../common/modal/AppModal";
import ThemePaletteModal from "../scene_theme_palette/ThemePaletteModal";
import { LuPalette, LuPencilLine } from "react-icons/lu";

// `languages.*` keys for the training-language picker.
const CONTENT_LANGUAGE_LABELS = {
  tr: "Turkish",
  en: "English",
  es: "Spanish",
  de: "German",
  fr: "French",
  ar: "Arabic",
  az: "Azerbaijani",
  ja: "Japanese",
};

/**
 * Global course configuration modal
 */
export default class GlobalConfig extends Component {
  /**
   * Constructor
   * @param props
   */
  constructor(props) {
    super(props);
    /* State from props is an anti-pattern*/
    this.state = {
      contentLanguage: this.initialContentLanguage(),
      title: this.props.globalConfig.title,
      author: this.props.globalConfig.author || "",
      canvasRatio: this.props.globalConfig.canvasRatio || 16 / 9,
      ratio: this.props.globalConfig.ratio || null,
      defaultSceneMandatory: normalizeSceneMandatoryDefaults(
        this.props.globalConfig.defaultSceneMandatory
      ),
      defaultSceneDuration:
        typeof this.props.globalConfig.defaultSceneDuration === "number"
          ? this.props.globalConfig.defaultSceneDuration
          : 0,
      age: this.props.globalConfig.age || { min: 0, max: 0 },
      typicalLearningTime: this.props.globalConfig.typicalLearningTime || { h: 0, m: 0, s: 0 },
      difficulty: this.props.globalConfig.difficulty,
      rights: this.props.globalConfig.rights || 1,
      description: this.props.globalConfig.description || "",
      thumbnail: this.props.globalConfig.thumbnail || img_place_holder,
      language: this.props.globalConfig.language,
      keywords: this.props.globalConfig.keywords || [],
      version: this.props.globalConfig.version || "0.0.0",
      status: this.props.globalConfig.status || "draft",
      context: this.props.globalConfig.context,
      jobWidgetVisible: this.props.globalConfig.jobWidgetVisible ?? false,
      chatbotOptIn: this.props.globalConfig.chatbotOptIn ?? false,
      hideGlobalScore: this.props.globalConfig.hideGlobalScore || false,
      defaultScore: this.props.globalConfig.defaultScore || 0,
      minTimeProgress: this.props.globalConfig.minTimeProgress || 3,
      visorNav: {
        ...(this.props.globalConfig.visorNav || {}),
        player:
          this.props.globalConfig.visorNav.player === undefined
            ? true
            : this.props.globalConfig.visorNav.player,
        sidebar:
          this.props.globalConfig.visorNav.sidebar === undefined
            ? true
            : this.props.globalConfig.visorNav.sidebar,
        keyBindings:
          this.props.globalConfig.visorNav.player === undefined
            ? true
            : this.props.globalConfig.visorNav.keyBindings,
        fixedPlayer:
          this.props.globalConfig.visorNav.fixedPlayer === undefined
            ? true
            : this.props.globalConfig.visorNav.player,
        timeBar:
          this.props.globalConfig.visorNav.timeBar === undefined
            ? true
            : this.props.globalConfig.visorNav.timeBar,
      },
      allowClone: this.props.globalConfig.allowClone
        ? true
        : this.props.globalConfig.allowClone === undefined,
      allowComments: this.props.globalConfig.allowComments
        ? true
        : this.props.globalConfig.allowComments === undefined,
      allowDownload: this.props.globalConfig.allowDownload
        ? true
        : this.props.globalConfig.allowDownload === undefined,
      modifiedState: false,
      showAlert: false,
      everPublished: this.props.globalConfig.everPublished,
      enableTimeline: this.props.globalConfig.enableTimeline,
      requiredCorrectAnswers: this.props.globalConfig.requiredCorrectAnswers || 0,
      showThemeModal: false,
      fontFamily: this.props.globalConfig.fontFamily || "",
      mode: getCourseMode(this.props.globalConfig),
    };
    // Tag handling functions
    this.handleDelete = this.handleDelete.bind(this);
    this.handleAddition = this.handleAddition.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.fileChanged = this.fileChanged.bind(this);
    this.calculateCommonScore = this.calculateCommonScore.bind(this);
    this.calculateTotalScore = this.calculateTotalScore.bind(this);

    let commonScore = this.calculateCommonScore();
    this.state.defaultScore = commonScore !== null ? commonScore : "-";
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      let commonScore = this.calculateCommonScore();
      this.setState({ defaultScore: commonScore !== null ? commonScore : "-" });
    }
  }

  calculateCommonScore() {
    let scores = [];
    if (!this.props.navItems) return 1;
    Object.values(this.props.navItems).forEach((item) => {
      if (item.type === "slide") {
        let weight =
          this.props.exercises &&
          this.props.exercises[item.id] &&
          this.props.exercises[item.id].weight !== undefined
            ? this.props.exercises[item.id].weight
            : 1;
        scores.push(weight);
      }
    });
    if (scores.length === 0) return 1;
    const allEqual = scores.every((v) => v === scores[0]);
    return allEqual ? scores[0] : null;
  }

  calculateTotalScore() {
    if (this.state.defaultScore !== "-") {
      let slideCount = Object.values(this.props.navItems).filter(
        (item) => item.type === "slide"
      ).length;
      return this.state.defaultScore * slideCount;
    }

    let total = 0;
    if (!this.props.navItems) return 0;
    Object.values(this.props.navItems).forEach((item) => {
      if (item.type === "slide") {
        let weight =
          this.props.exercises &&
          this.props.exercises[item.id] &&
          this.props.exercises[item.id].weight !== undefined
            ? parseFloat(this.props.exercises[item.id].weight)
            : 1;
        total += weight;
      }
    });
    return total;
  }

  calculateTotalQuestions() {
    if (!this.props.navItems || !this.props.exercises || !this.props.pluginToolbars) return 0;
    const uniqueExerciseIds = new Set();
    Object.keys(this.props.exercises).forEach((pageId) => {
      if (pageId.indexOf("cv-") !== 0) {
        let pageExercises = this.props.exercises[pageId].exercises || {};
        Object.keys(pageExercises).forEach((exerciseId) => {
          const pluginToolbar = this.props.pluginToolbars[exerciseId];
          if (pluginToolbar && pluginToolbar.state && pluginToolbar.state.buttons !== undefined) {
            uniqueExerciseIds.add(exerciseId);
          }
        });
      }
    });
    return uniqueExerciseIds.size;
  }

  handleRatioChange = (key) => {
    const value = getValueFromPreset(key);
    this.setState({
      modifiedState: true,
      ratio: key,
      canvasRatio: value,
    });
  };

  handleSceneDefaultsChange = (patch) => {
    this.setState((prev) => {
      if ("duration" in patch) return { modifiedState: true, defaultSceneDuration: patch.duration };
      if ("mandatory" in patch)
        return { modifiedState: true, defaultSceneMandatory: patch.mandatory };
      return null;
    });
  };

  collectGlobalConfigFromState = () => ({
    ...this.props.globalConfig,
    title: this.state.title,
    author: this.state.author,
    canvasRatio: this.state.canvasRatio,
    ratio: this.state.ratio,
    defaultSceneMandatory: this.state.defaultSceneMandatory,
    defaultSceneDuration: this.state.defaultSceneDuration,
    fontFamily: this.state.fontFamily,
    age: this.state.age,
    typicalLearningTime: this.state.typicalLearningTime,
    difficulty: this.state.difficulty,
    rights: this.state.rights,
    description: this.state.description,
    thumbnail: this.state.thumbnail,
    language: this.state.language,
    contentLanguage: this.state.contentLanguage,
    keywords: this.state.keywords,
    version: this.state.version,
    status: this.state.status,
    context: this.state.context,
    jobWidgetVisible: this.state.jobWidgetVisible,
    chatbotOptIn: this.state.chatbotOptIn,
    hideGlobalScore: this.state.hideGlobalScore,
    defaultScore: this.state.defaultScore,
    minTimeProgress: this.state.minTimeProgress,
    visorNav: this.state.visorNav,
    allowClone: this.state.allowClone,
    allowComments: this.state.allowComments,
    allowDownload: this.state.allowDownload,
    everPublished: this.state.everPublished,
    enableTimeline: this.state.enableTimeline,
    requiredCorrectAnswers: this.state.requiredCorrectAnswers,
    mode: this.state.mode,
  });

  // New trainings start in Turkish.
  initialContentLanguage = () => (this.props.mode === "newTraining" ? "tr" : getContentLanguage());

  handleSave = () => {
    const { mode } = this.props;
    const newRatioValue = this.state.canvasRatio;
    const oldRatioValue = this.props.globalConfig.canvasRatio;
    const ratioChanged =
      typeof oldRatioValue === "number" &&
      typeof newRatioValue === "number" &&
      Math.abs(newRatioValue - oldRatioValue) > 1e-6;

    // Stamp the "first-time configuration done" marker. Once the user has
    // confirmed the initial config (either via emptyHydrate forced popup or
    // via newTraining), we never want the forced popup to re-open on later
    // refreshes — even when the training still has only one empty scene.
    // Editing an existing training also flips the marker to true defensively
    // so legacy trainings opened once stop showing the popup.
    const mergedGlobalConfig = {
      ...this.collectGlobalConfigFromState(),
      initialConfigCompleted: true,
    };
    // Retypesetting every text box rewrites their stored HTML, so only do it
    // when the font actually changed in this session — not on every save.
    const fontChanged =
      !!this.state.fontFamily && this.state.fontFamily !== this.props.globalConfig.fontFamily;

    if (mode === "newTraining") {
      if (this.props.onCreateNewTraining) {
        this.props.onCreateNewTraining(mergedGlobalConfig);
      }
      return;
    }

    if (mode === "emptyHydrate" || !ratioChanged) {
      this.props.changeGlobalConfig("STATE", mergedGlobalConfig);
      // Preserve per-slide weight propagation that the legacy saveState used to do.
      if (
        this.props.navItems &&
        this.props.onConfigScore &&
        this.state.defaultScore !== "-" &&
        this.state.defaultScore !== "" &&
        this.state.defaultScore !== null &&
        this.state.defaultScore !== undefined
      ) {
        Object.values(this.props.navItems).forEach((item) => {
          if (item && item.type === "slide") {
            this.props.onConfigScore(item.id, "weight", this.state.defaultScore, item.id);
          }
        });
      }
      this.props.batchUpdateMandatoryDefaults(this.state.defaultSceneMandatory);
      if (fontChanged) this.props.batchSetSceneFont(this.state.fontFamily);
      this.props.close();
      return;
    }

    // mode === "edit" AND ratio changed → SaveAs chain
    if (this.props.onRequestSaveAs) {
      this.props.onRequestSaveAs({
        mergedGlobalConfig,
        oldRatio: oldRatioValue,
        newRatio: newRatioValue,
        applyMandatoryToAll: true,
        applyDurationToAll: false,
        applyFontToAll: fontChanged ? this.state.fontFamily : null,
      });
    }
    this.props.close();
  };

  attemptClose = () => {
    if (this.props.forced) return;
    if (this.state.modifiedState) {
      this.setState({ showAlert: true });
    } else {
      this.cancel();
    }
  };

  hasGlobalTheme = () => {
    const t = this.props.globalConfig?.globalTheme;
    return !!(t && (t.themeId || t.paletteId || t.themeHtml));
  };

  /**
   * Renders React component
   * @returns {code}
   */
  render() {
    const {
      title,
      author,
      typicalLearningTime,
      minTimeProgress,
      visorNav,
      description,
      enableTimeline,
      mode,
    } = this.state;

    return (
      <>
        <AppModal
          show={this.props.show}
          onClose={this.attemptClose}
          title={i18n.t("global_config.title")}
          size="xl"
          backdrop={this.props.forced ? "static" : true}
          keyboard={!this.props.forced}
          closeButton={!this.props.forced}
          className="gcModal"
          dialogClassName="gc-modal__dialog"
          bodyClassName="gc-modal__body"
          bodyProps={{ className: "gc-modal__body" }}
          footerProps={{ className: "gc-modal__footer" }}
          cancelLabel={!this.props.forced ? i18n.t("global_config.Discard") : undefined}
          onCancel={() => this.cancel()}
          confirmLabel={i18n.t("global_config.Accept")}
          onConfirm={() => this.handleSave()}
        >
          <Alert
            className="pageModal"
            show={this.state.showAlert}
            hasHeader
            title={i18n.t("messages.save_changes")}
            closeButton
            cancelButton
            acceptButtonText={"OK"}
            onClose={(bool) => {
              bool ? this.handleSave() : this.cancel();
              this.setState({ showAlert: false });
            }}
          >
            {i18n.t("global_config.prompt")}
          </Alert>

          <form className="gc-modal__form">
            <div className="gc-grid">
              {/* Column 1 — Identity & Geometry */}
              <div className="gc-col">
                <section className="gc-card">
                  <header className="gc-card__head">
                    <h6 className="gc-card__title">{i18n.t("global_config.group.general")}</h6>
                  </header>
                  <div className="gc-card__body gc-stack">
                    <div className="gc-field">
                      <label htmlFor="gc-title" className="gc-label">
                        {i18n.t("global_config.course_title")}
                      </label>
                      <input
                        id="gc-title"
                        type="text"
                        className="gc-input"
                        value={title}
                        placeholder={i18n.t("global_config.course_title")}
                        onChange={(e) =>
                          this.setState({ modifiedState: true, title: e.target.value })
                        }
                      />
                    </div>
                    <div className="gc-field">
                      <label htmlFor="gc-desc" className="gc-label">
                        {i18n.t("global_config.description")}
                      </label>
                      <textarea
                        id="gc-desc"
                        className="gc-input gc-textarea"
                        value={description}
                        rows={3}
                        placeholder={i18n.t("global_config.description_placeholder")}
                        onChange={(e) =>
                          this.setState({ modifiedState: true, description: e.target.value })
                        }
                      />
                    </div>
                    <div className="gc-field">
                      <label htmlFor="gc-author" className="gc-label">
                        {i18n.t("global_config.author")}
                      </label>
                      <input
                        id="gc-author"
                        type="text"
                        className="gc-input"
                        value={author}
                        placeholder={i18n.t("global_config.anonymous")}
                        onChange={(e) =>
                          this.setState({ modifiedState: true, author: e.target.value })
                        }
                      />
                    </div>
                    <div className="gc-field">
                      <label htmlFor="gc-mode" className="gc-label">
                        {i18n.t("global_config.mode")}
                      </label>
                      <select
                        id="gc-mode"
                        className="gc-input"
                        value={mode}
                        onChange={(e) =>
                          this.setState({ modifiedState: true, mode: e.target.value })
                        }
                      >
                        {COURSE_MODES.map((m) => (
                          <option key={m} value={m}>
                            {i18n.t(`global_config.mode_list.${m}`)}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="gc-field">
                      <label htmlFor="gc-content-language" className="gc-label">
                        {i18n.t("global_config.content_language")}
                      </label>
                      <select
                        id="gc-content-language"
                        className="gc-input"
                        value={this.state.contentLanguage}
                        onChange={(e) =>
                          this.setState({
                            modifiedState: true,
                            contentLanguage: e.target.value,
                          })
                        }
                      >
                        {CONTENT_LANGUAGES.map((code) => (
                          <option key={code} value={code}>
                            {i18n.t(`languages.${CONTENT_LANGUAGE_LABELS[code]}`)}
                          </option>
                        ))}
                      </select>
                      <p className="gc-hint">{i18n.t("global_config.content_language_hint")}</p>
                    </div>
                  </div>
                </section>

                <section className="gc-card">
                  <header className="gc-card__head">
                    <h6 className="gc-card__title">{i18n.t("global_config.group.geometry")}</h6>
                  </header>
                  <div className="gc-card__body">
                    <RatioPicker selectedKey={this.state.ratio} onChange={this.handleRatioChange} />
                  </div>
                </section>

                <section className="gc-card">
                  <header className="gc-card__head">
                    <h6 className="gc-card__title">{i18n.t("global_config.group.theme")}</h6>
                  </header>
                  <div className="gc-card__body">
                    <div className="gc-theme-row">
                      <div className="gc-theme-status">
                        <LuPalette aria-hidden="true" />
                        <span className="gc-theme-status__text">
                          {this.hasGlobalTheme()
                            ? i18n.t("ThemePalette.Title")
                            : i18n.t("ThemePalette.Custom") || "Custom"}
                        </span>
                      </div>
                      <button
                        type="button"
                        className="gc-modal__btn gc-modal__btn--ghost gc-modal__btn--compact"
                        onClick={() => this.setState({ showThemeModal: true })}
                      >
                        <LuPencilLine aria-hidden="true" />
                        <span>{i18n.t("ThemePalette.Select") || "Seç"}</span>
                      </button>
                    </div>
                  </div>
                </section>

                <section className="gc-card">
                  <header className="gc-card__head">
                    <h6 className="gc-card__title">{i18n.t("global_config.course_font")}</h6>
                  </header>
                  <div className="gc-card__body">
                    <CourseFontSection
                      value={this.state.fontFamily}
                      onChange={(fontFamily) => this.setState({ modifiedState: true, fontFamily })}
                    />
                  </div>
                </section>
              </div>

              {/* Column 2 — Behavior */}
              <div className="gc-col">
                <section className="gc-card">
                  <header className="gc-card__head">
                    <h6 className="gc-card__title">
                      {i18n.t("global_config.group.scene_defaults")}
                    </h6>
                  </header>
                  <div className="gc-card__body">
                    <SceneDefaultsSection
                      duration={this.state.defaultSceneDuration}
                      minTimeProgress={this.state.minTimeProgress}
                      mandatory={this.state.defaultSceneMandatory}
                      onChange={this.handleSceneDefaultsChange}
                    />
                  </div>
                </section>

                <section className="gc-card">
                  <header className="gc-card__head">
                    <h6 className="gc-card__title">
                      {i18n.t("global_config.group.progress_access")}
                    </h6>
                  </header>
                  <div className="gc-card__body gc-stack">
                    <div className="gc-row gc-row--split">
                      <div className="gc-field">
                        <label className="gc-label">
                          {i18n.t("global_config.typicalLearningTime")}
                        </label>
                        <div className="gc-input-row">
                          <div className="gc-input-affix">
                            <input
                              type="number"
                              className="gc-input"
                              value={typicalLearningTime.h}
                              min={0}
                              max={100}
                              onChange={(e) =>
                                this.setState({
                                  modifiedState: true,
                                  typicalLearningTime: {
                                    h: e.target.value,
                                    m: typicalLearningTime.m,
                                    s: typicalLearningTime.s,
                                  },
                                })
                              }
                            />
                            <span className="gc-input-affix__unit">h</span>
                          </div>
                          <div className="gc-input-affix">
                            <input
                              type="number"
                              className="gc-input"
                              value={typicalLearningTime.m}
                              min={0}
                              max={59}
                              onChange={(e) =>
                                this.setState({
                                  modifiedState: true,
                                  typicalLearningTime: {
                                    h: typicalLearningTime.h,
                                    m: e.target.value,
                                    s: typicalLearningTime.s,
                                  },
                                })
                              }
                            />
                            <span className="gc-input-affix__unit">m</span>
                          </div>
                        </div>
                      </div>

                      <div className="gc-field">
                        <label className="gc-label">
                          {i18n.t("global_config.minTimeProgress")}
                        </label>
                        <div className="gc-input-affix">
                          <input
                            type="number"
                            className="gc-input"
                            value={minTimeProgress}
                            min={1}
                            max={500}
                            onChange={(e) =>
                              this.setState({
                                modifiedState: true,
                                minTimeProgress: parseFloat(e.target.value) || 0,
                              })
                            }
                          />
                          <span className="gc-input-affix__unit">s</span>
                        </div>
                      </div>
                    </div>

                    <label className="gc-toggle-row">
                      <ToggleSwitch
                        onChange={() =>
                          this.setState({
                            modifiedState: true,
                            jobWidgetVisible: !this.state.jobWidgetVisible,
                          })
                        }
                        checked={this.state.jobWidgetVisible}
                      />
                      <span>{i18n.t("global_config.jobWidgetVisible")}</span>
                    </label>

                    <label className="gc-toggle-row">
                      <ToggleSwitch
                        onChange={() =>
                          this.setState({
                            modifiedState: true,
                            chatbotOptIn: !this.state.chatbotOptIn,
                          })
                        }
                        checked={this.state.chatbotOptIn}
                      />
                      <span>{i18n.t("global_config.chatbotEnabled")}</span>
                    </label>

                    <label className="gc-toggle-row">
                      <ToggleSwitch
                        onChange={() =>
                          this.setState({
                            modifiedState: true,
                            enableTimeline: !this.state.enableTimeline,
                          })
                        }
                        checked={enableTimeline}
                      />
                      <span>{i18n.t("global_config.timeline_visible")}</span>
                    </label>

                    <label className="gc-toggle-row">
                      <ToggleSwitch
                        onChange={() => {
                          const newValue = this.state.requiredCorrectAnswers > 0 ? 0 : 1;
                          this.setState({
                            modifiedState: true,
                            requiredCorrectAnswers: newValue,
                          });
                        }}
                        checked={this.state.requiredCorrectAnswers > 0}
                      />
                      <span>
                        {i18n.t("global_config.require_question_evaluation") ||
                          "Zorunlu Değerlendirme Sorusu"}
                      </span>
                    </label>

                    {this.state.requiredCorrectAnswers > 0 && (
                      <div className="gc-row gc-row--split">
                        <div className="gc-field">
                          <label className="gc-label gc-label--muted">
                            {i18n.t("global_config.total_questions")}
                          </label>
                          <div className="gc-static">{this.calculateTotalQuestions()}</div>
                        </div>
                        <div className="gc-field">
                          <label className="gc-label">
                            {i18n.t("global_config.required_correct_answers")}
                          </label>
                          <input
                            type="number"
                            className="gc-input"
                            value={this.state.requiredCorrectAnswers}
                            min={1}
                            max={this.calculateTotalQuestions()}
                            onChange={(e) =>
                              this.setState({
                                modifiedState: true,
                                requiredCorrectAnswers: parseInt(e.target.value) || 1,
                              })
                            }
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </section>

                <section className="gc-card">
                  <header className="gc-card__head">
                    <h6 className="gc-card__title">
                      {i18n.t("global_config.group.visor_navigation")}
                    </h6>
                  </header>
                  <div className="gc-card__body gc-stack">
                    <label className="gc-toggle-row">
                      <ToggleSwitch
                        onChange={() =>
                          this.setState({
                            modifiedState: true,
                            visorNav: {
                              ...visorNav,
                              player: !visorNav.player,
                              fixedPlayer: !visorNav.player,
                            },
                          })
                        }
                        checked={visorNav.player}
                      />
                      <span>{i18n.t("global_config.visor_nav.player")}</span>
                    </label>
                    <label className="gc-toggle-row">
                      <ToggleSwitch
                        onChange={() =>
                          this.setState({
                            modifiedState: true,
                            visorNav: { ...visorNav, sidebar: !visorNav.sidebar },
                          })
                        }
                        checked={visorNav.sidebar}
                      />
                      <span>{i18n.t("global_config.visor_nav.sidebar")}</span>
                    </label>
                    <label className="gc-toggle-row">
                      <ToggleSwitch
                        onChange={() =>
                          this.setState({
                            modifiedState: true,
                            visorNav: { ...visorNav, keyBindings: !visorNav.keyBindings },
                          })
                        }
                        checked={visorNav.keyBindings}
                      />
                      <span>{i18n.t("global_config.visor_nav.keybindings")}</span>
                    </label>
                  </div>
                </section>
              </div>
            </div>
          </form>
        </AppModal>

        <ThemePaletteModal
          show={this.state.showThemeModal}
          onClose={() => this.setState({ showThemeModal: false })}
          onAddImageModalToggle={this.props.onAddImageModalToggle}
        />
      </>
    );
  }

  /** *
   * Keyword deleted callback
   * @param i position of the keyword
   */
  handleDelete(i) {
    let tags = Object.assign([], this.state.keywords);
    tags.splice(i, 1);
    this.setState({ modifiedState: true, keywords: tags });
  }

  /**
   * Keyword added callback
   * @param tag Keyword name
   */
  handleAddition(tag) {
    let tags = Object.assign([], this.state.keywords);
    tags.push(tag.text);
    this.setState({ modifiedState: true, keywords: tags });
  }

  /**
   * Keyword moved callback
   * @param tag Tag moving
   * @param currPos Current position
   * @param newPos New position
   */
  handleDrag(tag, currPos, newPos) {
    let tags = Object.assign([], this.state.keywords);
    // mutate array
    tags.splice(currPos, 1);
    tags.splice(newPos, 0, tag.text);
    // re-render
    this.setState({ modifiedState: true, keywords: tags });
  }

  /**
   * Save configuration changes
   */
  saveState() {
    this.setState({ modifiedState: false });

    if (this.state.defaultScore !== "-" && this.state.defaultScore !== "") {
      Object.values(this.props.navItems).forEach((item) => {
        if (item.type === "slide") {
          this.props.onConfigScore(item.id, "weight", this.state.defaultScore, item.id);
        }
      });
      this.state.defaultScore = parseFloat(this.state.defaultScore);
    }

    let stateToSave = { ...this.state };
    if (stateToSave.defaultScore === "-" || stateToSave.defaultScore === "") {
      stateToSave.defaultScore = this.props.globalConfig.defaultScore || 1;
    }
    this.props.changeGlobalConfig("STATE", stateToSave);
    this.props.close();
  }

  getCurrentPageAvatar() {
    let element;
    if (document.getElementsByClassName("scrollcontainer").length > 0) {
      element = document.getElementsByClassName("scrollcontainer")[0];
    } else {
      element = document.getElementById("maincontent");
    }

    let clone = element.cloneNode(true);

    let style = clone.style;
    style.width = "600px";
    style.position = "relative";
    style.top = window.innerHeight + "px";
    style.left = 0;
    document.body.appendChild(clone);

    html2canvas(clone, {
      onrendered: (canvas) => {
        let extra_canvas = document.createElement("canvas");

        extra_canvas.setAttribute("width", 500);
        extra_canvas.setAttribute("height", 500);
        let ctx = extra_canvas.getContext("2d");
        ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, 500, 500);
        extra_canvas.toBlob((blob) => {
          let file = new File([blob], "avatar.png", { type: "image/png" });
          this.props.uploadFunction(
            file,
            "",
            (thumbnail) => {
              this.setState({ modifiedState: true, thumbnail });
            },
            "image/png"
          );
        });

        // Uncomment this lines to download the image directly
        // let a = document.createElement('a');
        // a.href = a.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
        // a.click();
        document.body.removeChild(clone);
        // this.setState({modifiedState: true, thumbnail: extra_canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream") });
      },
      useCORS: true,
    });
  }

  fileChanged(event) {
    let files = event.target.files;
    let file = files[0];
    let gc = this;
    let reader = new FileReader();
    reader.onload = () => {
      let data = reader.result;
      let img = new Image();
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.width = 500;
        canvas.height = canvas.width * (img.height / img.width);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        gc.setState({
          modifiedState: true,
          thumbnail: canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream"),
        });
      };
      img.src = data;
    };
    reader.readAsDataURL(file);
  }

  /**
   * Discard configuration changes
   */
  cancel() {
    this.setState({
      title: this.props.globalConfig.title,
      author: this.props.globalConfig.author || "",
      ratio: this.props.globalConfig.ratio || null,
      canvasRatio: this.props.globalConfig.canvasRatio || 16 / 9,
      age: this.props.globalConfig.age || { min: 0, max: 0 },
      typicalLearningTime: this.props.globalConfig.typicalLearningTime || { h: 0, m: 0, s: 0 },
      difficulty: this.props.globalConfig.difficulty,
      rights: this.props.globalConfig.rights || 1,
      description: this.props.globalConfig.description || "",
      language: this.props.globalConfig.language || undefined,
      keywords: this.props.globalConfig.keywords || [],
      thumbnail: this.props.globalConfig.thumbnail || img_place_holder,
      version: this.props.globalConfig.version || "0.0.0",
      status: this.props.globalConfig.status || "draft",
      context: this.props.globalConfig.context,
      jobWidgetVisible: this.props.globalConfig.jobWidgetVisible ?? false,
      chatbotOptIn: this.props.globalConfig.chatbotOptIn ?? false,
      allowComments: this.props.globalConfig.allowComments,
      allowClone: this.props.globalConfig.allowClone,
      allowDownload: this.props.globalConfig.allowDownload,
      hideGlobalScore: this.props.globalConfig.hideGlobalScore || false,
      minTimeProgress: this.props.globalConfig.minTimeProgress || 3,
      requiredCorrectAnswers: this.props.globalConfig.requiredCorrectAnswers || 0,
      enableTimeline: this.props.globalConfig.enableTimeline ?? true,
      visorNav: this.props.globalConfig.visorNav || {
        player: true,
        sidebar: true,
        keyBindings: true,
      },
      defaultSceneMandatory: normalizeSceneMandatoryDefaults(
        this.props.globalConfig.defaultSceneMandatory
      ),
      defaultSceneDuration:
        typeof this.props.globalConfig.defaultSceneDuration === "number"
          ? this.props.globalConfig.defaultSceneDuration
          : 0,
      fontFamily: this.props.globalConfig.fontFamily || "",
      mode: getCourseMode(this.props.globalConfig),
      modifiedState: false,
      everPublished: this.props.globalConfig.everPublished,
    });

    //  Comment the following line if you don't want to exit when changes are discarded
    this.props.close();
  }

  /**
   * If title is changed from outside
   * @param prevProps
   */
  componentDidUpdate(prevProps) {
    if (this.props.globalConfig.title !== prevProps.globalConfig.title) {
      this.setState({
        title: this.props.globalConfig.title || "",
      });
    }
    if (this.props.globalConfig.status !== prevProps.globalConfig.status) {
      this.setState({
        status: this.props.globalConfig.status || "draft",
      });
    }
    if (
      this.props.fileModalResult &&
      prevProps.fileModalResult &&
      this.props.fileModalResult.value !== prevProps.fileModalResult.value &&
      this.props.fileModalResult.value &&
      this.props.fileModalResult.id === "avatar"
    ) {
      this.setState({
        thumbnail: this.props.fileModalResult.value,
        modifiedState: true,
      });
    }

    if (!prevProps.show && this.props.show) {
      this.setState({
        contentLanguage: this.initialContentLanguage(),
        title: this.props.globalConfig.title || "",
        author: this.props.globalConfig.author || "",
        ratio: this.props.globalConfig.ratio || null,
        canvasRatio: this.props.globalConfig.canvasRatio || 16 / 9,
        age: this.props.globalConfig.age || { min: 0, max: 0 },
        typicalLearningTime: this.props.globalConfig.typicalLearningTime || { h: 0, m: 0, s: 0 },
        difficulty: this.props.globalConfig.difficulty,
        rights: this.props.globalConfig.rights || 1,
        description: this.props.globalConfig.description || "",
        thumbnail: this.props.globalConfig.thumbnail || img_place_holder,
        language: this.props.globalConfig.language,
        keywords: this.props.globalConfig.keywords || [],
        version: this.props.globalConfig.version || "0.0.0",
        status: this.props.globalConfig.status || "draft",
        context: this.props.globalConfig.context,
        jobWidgetVisible: this.props.globalConfig.jobWidgetVisible ?? false,
        chatbotOptIn: this.props.globalConfig.chatbotOptIn ?? false,
        allowComments: this.props.globalConfig.allowComments
          ? true
          : this.props.globalConfig.allowComments === undefined,
        allowClone: this.props.globalConfig.allowClone
          ? true
          : this.props.globalConfig.allowClone === undefined,
        allowDownload: this.props.globalConfig.allowDownload
          ? true
          : this.props.globalConfig.allowDownload === undefined,
        hideGlobalScore: this.props.globalConfig.hideGlobalScore || false,
        defaultScore: this.calculateCommonScore() !== null ? this.calculateCommonScore() : "-",
        minTimeProgress: this.props.globalConfig.minTimeProgress || 3,
        requiredCorrectAnswers: this.props.globalConfig.requiredCorrectAnswers || 0,
        enableTimeline: this.props.globalConfig.enableTimeline ?? true,
        defaultSceneMandatory: normalizeSceneMandatoryDefaults(
          this.props.globalConfig.defaultSceneMandatory
        ),
        defaultSceneDuration:
          typeof this.props.globalConfig.defaultSceneDuration === "number"
            ? this.props.globalConfig.defaultSceneDuration
            : 0,
        fontFamily: this.props.globalConfig.fontFamily || "",
        mode: getCourseMode(this.props.globalConfig),
        visorNav: {
          ...(this.props.globalConfig.visorNav || {}),
          player:
            this.props.globalConfig.visorNav.player === undefined
              ? true
              : this.props.globalConfig.visorNav.player,
          sidebar:
            this.props.globalConfig.visorNav.sidebar === undefined
              ? true
              : this.props.globalConfig.visorNav.sidebar,
          keyBindings:
            this.props.globalConfig.visorNav.keyBindings === undefined
              ? true
              : this.props.globalConfig.visorNav.keyBindings,
          fixedPlayer:
            this.props.globalConfig.visorNav.fixedPlayer === undefined
              ? true
              : this.props.globalConfig.visorNav.fixedPlayer,
        },
        modifiedState: false,
        showAlert: false,
        everPublished: this.props.globalConfig.everPublished,
      });
    }
  }
}

GlobalConfig.propTypes = {
  /**
   * Indicates whether the course configuration modal should be shown or hidden
   */
  show: PropTypes.bool,
  /**
   * Configuration course dictionary. Object identical to Redux state ***globalConfig*** .
   */
  globalConfig: PropTypes.object.isRequired,
  /**
   * Saves new configuration
   */
  changeGlobalConfig: PropTypes.func.isRequired,
  /**
   * Closes course configuration modal
   */
  close: PropTypes.func.isRequired,
  /**
   * Forwarded to ThemePaletteModal for the Custom/Image background picker.
   */
  onAddImageModalToggle: PropTypes.func,
  /**
   *  Function for uploading a file to the server
   */
  uploadFunction: PropTypes.func.isRequired,
  /**
   * Save mode: "edit" (in-place save), "emptyHydrate" (forced first-open),
   * "newTraining" (creates a brand-new training via _saveAs).
   */
  mode: PropTypes.oneOf(["edit", "emptyHydrate", "newTraining"]),
  /**
   * When true, hides Cancel/close paths so the modal can only be closed via Save.
   */
  forced: PropTypes.bool,
  /**
   * Called by Save when mode === "newTraining".
   */
  onCreateNewTraining: PropTypes.func,
  /**
   * Called by Save when mode === "edit" AND ratio changed — opens SaveAs chain.
   */
  onRequestSaveAs: PropTypes.func,
  /**
   * Dispatches the BATCH_UPDATE_MANDATORY_DEFAULTS reducer action.
   */
  batchUpdateMandatoryDefaults: PropTypes.func,
  /**
   * Dispatches the BATCH_UPDATE_SCENE_DURATION reducer action.
   */
  batchUpdateSceneDuration: PropTypes.func,
  /**
   * Dispatches the BATCH_SET_SCENE_FONT reducer action (course-wide font).
   */
  batchSetSceneFont: PropTypes.func,
};

GlobalConfig.defaultProps = {
  mode: "edit",
  forced: false,
  onCreateNewTraining: null,
  onRequestSaveAs: null,
  batchUpdateMandatoryDefaults: () => {},
  batchUpdateSceneDuration: () => {},
  batchSetSceneFont: () => {},
};
